import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('12px'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('8px'),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.padding('16px'),
    boxShadow: 'none',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  title: {
    fontSize: '14px',
  },
  assignmentCard: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground1,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  assignmentContent: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('16px'),
    minWidth: 0,
  },
  assignmentTitle: {
    fontSize: '20px',
    lineHeight: '28px',
  },
  assignedCard: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('6px'),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    boxShadow: 'none',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  assignedContent: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('18px'),
    minWidth: 0,
  },
  assignedTitle: {
    fontSize: '16px',
    lineHeight: '20px',
  },
  assignedName: {
    fontWeight: tokens.fontWeightSemibold,
  },
  assignedActions: {
    display: 'flex',
    flexWrap: 'wrap',
    ...shorthands.gap('10px'),
  },
  messageRow: {
    display: 'flex',
    alignItems: 'flex-start',
    ...shorthands.gap('8px'),
    minWidth: 0,
    width: '100%',
    boxSizing: 'border-box',
  },
  infoIcon: {
    flexShrink: 0,
    marginTop: '2px',
    color: tokens.colorBrandForeground1,
    fontSize: '16px',
  },
  assignmentInfoIcon: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground1,
    fontSize: '20px',
  },
  messageText: {
    minWidth: 0,
    flex: 1,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  previewError: {
    color: tokens.colorPaletteRedForeground1,
  },
  ctaButton: {
    alignSelf: 'flex-start',
    minHeight: '32px',
    boxSizing: 'border-box',
    '@media (max-width: 700px)': {
      alignSelf: 'stretch',
      width: '100%',
    },
  },
  stateContainer: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('8px'),
    ...shorthands.padding('16px'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('8px'),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
  },
});
